<section class="feedback">
    <div class="feedback-header">
        <div class="feedback-header__title">Свяжитесь с нами</div>
        <button
            class="feedback-header__close"
            type="button"
            (click)="attemptClose()"
        ></button>
    </div>
    <div class="feedback__body">
        <div class="feedback__loader-container" *ngIf="loading">
            <loader type="page" message="Отправляем обращение..."> </loader>
        </div>

        <!-- Контейнер основного контента, который сохраняет размер -->
        <div class="feedback__form-container" *ngIf="!loading">
            <!-- Форма -->
            <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
                <!-- Почта отправителя -->
                <div class="form__field">
                    <input
                        #focusInput
                        id="email"
                        type="email"
                        formControlName="email"
                        placeholder="E-mail*"
                    />
                </div>

                <!-- Тема сообщения -->
                <div class="form__field">
                    <div
                        #subjectDropdown
                        class="dropdown"
                        tabindex="0"
                        (click)="toggleSubjectDropdown()"
                    >
                        <span class="dropdown__selected">{{
                            selectedSubject?.title || 'Выберите тип обращения*'
                        }}</span>
                        <img
                            src="./assets/icons/navigation/dropdown.svg"
                            class="dropdown__arrow"
                            [class.open]="isSubjectOpen"
                        />

                        <div class="dropdown__list" *ngIf="isSubjectOpen">
                            <div
                                class="dropdown__list-item"
                                *ngFor="let subject of subjectOptions"
                                (click)="selectSubject(subject, $event)"
                            >
                                {{ subject.title }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Подтема сообщения -->
                <div
                    class="form__field"
                    *ngIf="
                        selectedSubject?.subthemes &&
                        selectedSubject.subthemes.length > 0
                    "
                >
                    <div
                        #subsubjectDropdown
                        class="dropdown"
                        (click)="toggleSubsubjectDropdown()"
                        tabindex="0"
                    >
                        <span class="dropdown__selected">{{
                            selectedSubsubject || 'Уточните тему'
                        }}</span>
                        <img
                            src="./assets/icons/navigation/dropdown.svg"
                            class="dropdown__arrow"
                            [class.open]="isSubsubjectOpen"
                        />

                        <div class="dropdown__list" *ngIf="isSubsubjectOpen">
                            <div
                                class="dropdown__list-item"
                                *ngFor="
                                    let subsubject of selectedSubject.subthemes
                                "
                                (click)="selectSubsubject(subsubject, $event)"
                            >
                                {{ subsubject }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Сообщение -->
                <div class="form__field">
                    <textarea
                        id="message"
                        formControlName="message"
                        maxlength="1000"
                        placeholder="Сообщение*"
                        style="resize: none"
                    ></textarea>
                </div>

                <!-- Кнопка отправки -->
                <button
                    mat-raised-button
                    type="submit"
                    [disabled]="form.invalid"
                    class="form__submit"
                >
                    <ng-container *ngIf="!loading">Отправить</ng-container>
                    <ng-container *ngIf="loading">
                        <div class="form__submit-loader"></div>
                    </ng-container>
                </button>
            </form>

            <!-- Диалог подтверждения поверх формы -->

            <div class="confirmation-dialog" *ngIf="showConfirmation">
                <div class="confirmation-dialog__container">
                    <!-- <div class="confirmation-dialog"> -->
                    <div class="confirmation-dialog__header">
                        <h3>Подтвердите закрытие</h3>
                    </div>
                    <div class="confirmation-dialog__body">
                        <p>
                            Вы уверены, что хотите закрыть форму обратной связи?
                            Все несохраненные данные будут потеряны.
                        </p>
                    </div>
                    <div class="confirmation-dialog__footer">
                        <button
                            class="confirmation-dialog__button button-cancel"
                            (click)="cancelClose()"
                        >
                            Вернуться
                        </button>
                        <button
                            class="confirmation-dialog__button button-primary"
                            (click)="confirmClose()"
                        >
                            Да, закрыть
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
